export const HEALTH_CHECK_LAMBDA = 'health_check_lambda' as const;
export const APPROVAL_MASS_ACTION_LAMBDA = 'approval_mass_action_lambda' as const;
export const REJECTION_MASS_ACTION_LAMBDA = 'rejection_mass_action_lambda' as const;
